import { createUseStyles } from 'react-jss'
import { LIGHT_GRAY, DARK_GRAY_20, NOT_AS_BRIGHT_GRAY } from '@omnilert/components'

export default createUseStyles({
  link: {
    '&:not(:last-child)': {
      borderBottom: `1px solid ${DARK_GRAY_20}`
    },
    padding: '20px 0px',
    textDecoration: 'none',
    width: '100%'
  },
  list: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 10px',
    marginBottom: '0 !important',
    overflow: 'auto'
  },
  listItem: {
    display: 'flex'
  },
  noResults: {
    color: 'var(--no-results__text)',
    display: 'flex',
    justifyContent: 'center'
  },
  resourcesContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'flex-start !important',
    width: '100%'
  },
  responsive: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    width: '100% !important',
    backgroundColor: 'var(--secondary__page__background__color)',
    justifyContent: 'flex-start !important'
  },
  searchContainer: {
    alignItems: 'center',
    display: 'flex',
    position: 'relative',
    padding: '24px 10px 0 10px'
  },
  searchIcon: {
    position: 'absolute',
    right: '30px',
    '--icon__primary__stroke__color': [[LIGHT_GRAY], '!important'],
    '&:hover': {
      cursor: 'pointer'
    }
  },
  searchInput: {
    borderRadius: [['5px'], '!important'],
    overflow: 'hidden',
    paddingRight: '40px !important',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '&::placeholder': {
      color: [[LIGHT_GRAY], '!important'],
      opacity: [1, '!important']
    }
  },
  spacer: {
    backgroundColor: NOT_AS_BRIGHT_GRAY,
    height: '100%'
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '10px'
  },
  title: {
    fontWeight: '700 !important'
  }
})

